import moment, { Moment } from 'moment';

import { VehicleOfficeSearchViewModel } from '@api/index';

export interface ICarRentalAutoComplateViewModel {
  airportId: number;
  airportCode: string;
  airportName: string;
  cityCode: string;
  cityName: string;
  countryCode: string;
  countryName: string;
  isCity: boolean;
}
export interface ICarRentalSearchBarState {
  departure: VehicleOfficeSearchViewModel | null;
  arrival: VehicleOfficeSearchViewModel | null;
  pickUpDate: Moment;
  dropUpDate: Moment;
  pickUpTime: string;
  dropUpTime: string;
  isDifferentLocation: boolean;
}

export const initialState: ICarRentalSearchBarState = {
  departure: null,
  arrival: null,
  pickUpDate: moment().add(7, 'days'),
  dropUpDate: moment().add(9, 'days'),
  pickUpTime: '09:00',
  dropUpTime: '09:00',
  isDifferentLocation: false,
};
